// Setup namespaces
var Sitepackage = Sitepackage || {
    'Plugin': {
        'Reservation': {}
    }
};


/**
 * Reservation plugin.
 *
 * @class
 */
Sitepackage.Plugin.Reservation = (function () {
    /**
     * Initializes the plugin.
     *
     * @param {Element} containers Main containers of this plugin
     *
     * @constructor
     */
    var Reservation = function (containers) {
        const self = this;
        // Main container of this plugin
        this.containers = containers;

        // Contains all actions
        this.actions = {
            'list': [],
            'wizard': [],
            'showcode': [],
            'showoutdated': []
        };

        // Event listeners
        this.listener = {
            'actionInitialized': [],
            'newPageLoaded': []
        };

        // Each container will consist of a plugin action
        var actionContainer, action;

        this.containers.forEach(function (container) {

            actionContainer = container.querySelector('[data-action="list"]');
            if (actionContainer) {
                action = new Sitepackage.Plugin.Reservation.ListAction(self, container, actionContainer);
                self.actions.list.push(action);
                self.dispatchEvent('actionInitialized', ['list', action]);
                return;
            }

            actionContainer = container.querySelector('[data-action="wizard"]');
            if (actionContainer) {
                action = new Sitepackage.Plugin.Reservation.WizardAction(self, container, actionContainer);
                self.actions.wizard.push(action);
                self.dispatchEvent('actionInitialized', ['wizard', action]);
                return;
            }

            actionContainer = container.querySelector('[data-action="showcode"]');
            if (actionContainer) {
                action = new Sitepackage.Plugin.Reservation.ShowcodeAction(self, container, actionContainer);
                self.actions.showcode.push(action);
                self.dispatchEvent('actionInitialized', ['showcode', action]);
                return;
            }

            actionContainer = container.querySelector('[data-action="showoutdated"]');
            if (actionContainer) {
                action = new Sitepackage.Plugin.Reservation.ShowoutdatedAction(self, container, actionContainer);
                self.actions.showoutdated.push(action);
                self.dispatchEvent('actionInitialized', ['showoutdated', action]);
                return;
            }


        });
    };

    /**
     * Notifies the given event.
     *
     * @param {string} event Name of the event to notify
     * @param {Object} data (Optional) Data to pass to the listeners (defaults to nothing)
     *
     * @returns {void}
     */
    Reservation.prototype.dispatchEvent = function (event, data) {
        if (!this.listener.hasOwnProperty(event)) {
            throw new Error('Event "' + event + '" does not exist.');
        }

        this.listener[event].forEach(function (callback) {
            callback(data);
        });
    };


    /**
     * Returns the main container of this plugin.
     *
     * @returns {Element}
     */
    Reservation.prototype.getContainer = function () {
        return this.container;
    };


    return Reservation;
})();

